<template>
	<div>
		<h4>Preview</h4>
		<div class="preview-container" :style="{backgroundColor: design.background_color,backgroundImage: 'url(\'' + design.background_image + '\')', color: design.text_color}">
			<div class="preview-content" :style="{'font-family': design.font_family.family, 'font-weight': design.font_weight}">
				<div class="preview-header" :style="{backgroundImage: 'url(\'' + design.header_image + '\')'}"></div>
				<div class="preview-form-instructions" :style="{color: design.text_color}">
					{{ form.form_instructions }}
				</div>
				<div class="preview-form">
					<input v-if="form.fields.full_name.request" type="text" class="form-control margin-top-10 preview-input" :placeholder="`FULL NAME${form.fields.full_name.require ? '*' : ''}`" :style="{backgroundColor: design.input_background_color, color: design.input_text_color}">
    				<input v-if="form.fields.email.request" type="text" class="form-control margin-top-10 preview-input" :placeholder="`EMAIL${form.fields.email.require ? '*' : ''}`" :style="{backgroundColor: design.input_background_color, color: design.input_text_color}">
    				<input v-if="form.fields.phone.request" type="text" class="form-control margin-top-10 preview-input" :placeholder="`PHONE${form.fields.phone.require ? '*' : ''}`" :style="{backgroundColor: design.input_background_color, color: design.input_text_color}">
    				<div class="preview-dob" v-if="form.fields.dob.request">
    					<p class="margin-top-20">Date of Birth</p>
    					<input type="text" class="form-control margin-right-10 preview-input dob-input-style" :placeholder="`MM${form.fields.dob.require ? '*' : ''}`" :style="{backgroundColor: design.input_background_color, color: design.input_text_color}">
    					<input type="text" class="form-control margin-right-10 preview-input dob-input-style" :placeholder="`DD${form.fields.dob.require ? '*' : ''}`" :style="{backgroundColor: design.input_background_color, color: design.input_text_color}">
    					<input type="text" class="form-control preview-input dob-input-style" :placeholder="`YYYY${form.fields.dob.require ? '*' : ''}`" :style="{backgroundColor: design.input_background_color, color: design.input_text_color}">
    				</div>
    				<button type="button" class="preview-button btn default margin-top-20 full-width" :style="{backgroundColor: design.button_background_color, color: design.button_text_color, 'font-weight': design.font_weight}">SUBMIT</button>
    				<div class="preview-agreement">
    					<p v-if="agreement.urls[0].url.length || agreement.urls[0].name.length || agreement.urls[1].url.length || agreement.urls[1].name.length">
    						I have read and agree to the <a :href="agreement.urls[0].url">{{ agreement.urls[0].name || agreement.urls[0].url }}</a><span v-if="agreement.urls[1].url.length || agreement.urls[1].name.length"> and <a :href="agreement.urls[1].url">{{ agreement.urls[1].name || agreement.urls[1].url }}</a></span>
    					</p>
    				</div>
				</div>
			</div>
			<div class="preview-footer" :style="{backgroundColor: design.footer_background_color, borderTop: (design.footer_border_color ? `5px solid ${design.footer_border_color}` : 'none')}">
				<img v-if="design.footer_image.length" :src="design.footer_image">
			</div>
		</div>
	</div>
</template>
<script>
/**
 * Typeahead module is used to build a front end search through data.
 * @class ContestPreview
 * @extends UNOgames
 * @prop {object} design - Used to pass the design options to the preview
 * @prop {object} form - Used to pass the form options to the preview
 * @prop {object} agreement - Used to pass the agreement options to the preview
 * @since 0.0.9
 */

export default {
	name: 'contest-preview',
	props: {
		design: {
			default: {}
		},
		form: {
			default: {}
		},
		agreement: {
			default: {}
		}
	}
}
</script>
<style>
.preview-container {
	position: relative;
	border: 1px solid #eee;
	height: 550px;
	width: 340px;
	margin: 10px auto;
	background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
	z-index: 999;
}
.preview-content {
	height: 85%;
    width: 85%;
    margin: 0 auto;
    text-align: center;
    margin-top: 20px;
}
.preview-content .preview-header {
	margin: auto;
    width: 150px;
    height: 125px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
}
.preview-content .preview-form-instructions {
	font-size: 14px;
    color: #000;
    font-family: Open Sans;
    font-weight: 400;
    margin-top: 10px;
    word-break: break-word;
}
.preview-container .preview-footer {
	position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    z-index: -1;
    padding-top: 10px;
    padding-bottom: 10px;
}
.preview-container .preview-footer img {
	max-width: 90%;
}
.preview-content .preview-agreement p {
	font-size: 12px;
	margin-top: 20px !important;
}
.preview-content .preview-form .preview-dob p {
	font-size: 14px;
}
.form-control.dob-input-style {
	width: 30%;
	float: left;
}
.full-width {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// ContestPreview.vue?7c15316a